import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../api";
import { notify } from "../../utils/toast";
import axios from "axios";

export const Employees = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);

  const getData = async () => {
    try {
      let token = localStorage.getItem("admintoken");
      axios.defaults.headers.common["Authorization"] = token;
      const response = await api.getEmployees();
      console.log(response);
      if (response?.success) {
        setData(response?.employees || []);
      }
    } catch (error) {
      notify.error("Something went wrong");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const delteEmployee = async (id) => {
    try {
      const response = await api.deleteEmployee(id);
      console.log(response);
      if (response?.success) {
        getData();
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        <div className="row">
          <div className="col">
            <h3>Employees</h3>
            <Table data={data} delteEmployee={delteEmployee} />
          </div>
        </div>
        <Link to={"/admin/add-employee"} className="AddEmpBtn">
          <i className="fa-solid fa-plus"></i>
        </Link>
      </div>
      {/* /.container-fluid */}
    </>
  );
};

const Table = ({ data, delteEmployee }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY");
    return dateTemp;
  };

  return (
    <>
      <div className="TableMain mt-3">
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th scope="col" className="">
                  Full Name
                </th>
                <th scope="col" className="">
                  Email Address
                </th>
                <th scope="col" className="">
                  DOB
                </th>
                <th scope="col" className="">
                  Gender
                </th>
                <th scope="col" className="">
                  Status
                </th>
                <th scope="col" className="">
                  Contact
                </th>
                <th scope="col" className="">
                  Emgergency Contact
                </th>
                <th scope="col" className="">
                  Join At
                </th>
                <th scope="col" className=""></th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => (
                <tr key={key}>
                  <td>
                    <div className="table-text-dark w-max-c db">
                      {item?.fullName}
                    </div>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.email}
                    </span>
                  </td>
                  <td scope="row">
                    <div className="table-text-dark w-max-c db">
                      {item?.dob ? formatDate(item?.dob) : "-"}
                    </div>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.gender}
                    </span>
                  </td>
                  <td>
                    <div className="w-max-c">
                      {item?.currentStatus == "Active" ? (
                        <span class="badge bg-success">
                          {item?.currentStatus}
                        </span>
                      ) : (
                        <span class="badge bg-danger">
                          {item?.currentStatus}
                        </span>
                      )}
                    </div>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.contactNumber || "-"}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.emergencyNumber || "-"}
                    </span>
                  </td>
                  <td>
                    {item?.joiningDate ? formatDate(item?.joiningDate) : "-"}
                  </td>
                  <td>
                    <div className="d-flex ai-center">
                      <Link
                        to={`/admin/employee/${item?._id}`}
                        className="p-2 cursor-pointer color-dark"
                      >
                        <i className="fa-solid fa-eye"></i>
                      </Link>{" "}
                      <Link
                        to={`/admin/edit-employee/${item?._id}`}
                        className="p-2 ms-1 cursor-pointer color-dark"
                      >
                        <i className="fa-solid fa-pen-to-square"></i>
                      </Link>{" "}
                      <div
                        className="delete p-2 ms-1 cursor-pointer"
                        onClick={() => delteEmployee(item?._id)}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
